import { useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
/** Shared visual feedback only; never intercept or delay an input event. */
export function useQuietMotion() {
    const reducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
    // Start quietly for keyboard and programmatically opened surfaces.
    const [keyboardInput, setKeyboardInput] = useState(true);
    useEffect(() => {
        const keyboard = () => setKeyboardInput(true);
        const pointer = () => setKeyboardInput(false);
        document.addEventListener('keydown', keyboard, true);
        document.addEventListener('pointerdown', pointer, true);
        return () => {
            document.removeEventListener('keydown', keyboard, true);
            document.removeEventListener('pointerdown', pointer, true);
        };
    }, []);
    return reducedMotion || keyboardInput;
}
